module.exports = __webpack_public_path__ + "img/chat-gpt-integration-cover.b27682ec.jpg";